export const handbookCopy = {
  handb_prev: "Previous",
  handb_next: "Next",
  handb_on_this_page: "On this page",
  handb_like_dislike_title: "Is this page helpful?",
  handb_like_desc: "Yes",
  handb_dislike_desc: "No",
  handb_thanks: "Thanks for the feedback",
}
